<template>
    <div class="introduction">
        <div v-html="content" class="ql-editor ql-snow"></div>
        <!-- <img src="../assets/introduction_banner.png" alt="">
        <div class="content">
            <p>
                武汉高德信息产业有限公司成立于2001年，位于中国•武汉•光谷，是武汉东湖新技术开发区认定的一家具有独立自主知识产权和领先技术的高新技术企业、软件企业。 一带一路暨金砖国家技能发展国际联盟会员单位、全国机械行业工业机器人与智能装备职业教育集团理事单位、教育部财政部认证备案的省级远程教育培训机构、武汉市认定的“千企万人计划”支持企业、武汉市智能制造职教集团理事单位。
            </p>
            <p>
                 成立17年以来，网络教育业务合作伙伴有华中科技大学、武汉大学、武汉理工、中国地质大学等985、211高校、职业院校及培训机构、出版社等超过100所合作机构。公司共获得软件著作权42个，软件产品12个，专利1项。沉淀了100000多学时的课程，4000余门在线课程资源，涉及财务、计算机、安全生产、管理、机械、人事、技能培训等20多个专业门类课程。
            </p>
            <p>
                2014年高德信息专注于工业机器人、高端数控技术、工业大数据、3d打印等智能制造领域的多维教材、虚拟仿真实训系统、在线课程、教学资源库、专业教学培训等教学产品研发。公司致力于打造国内一流的智能制造专业领域课程研发、教学与培训服务中心，搭建最专业的智能制造领域在线学习与就业咨询服务平台。帮助解决中国制造产业升级带来的人才缺失问题，助力“中国制造2025”。
公司坚持“做超越用户预期的产品，持续产品迭代持续微创新”，专注用户、专注产品、专注教育。海阔凭鱼跃，天高任鸟飞，面对市场机遇与挑战，高德信息欢迎有情怀、有技术、有能力的精英加入。
            </p>
        </div> -->
    </div>
</template>
<script>
import {getAboutUsApi} from "@/request/api"
export default {
    name:'aboutIntroduction',
    mounted(){
        this.init()
    },
    data(){
        return{
            content:''
        }
    },
    methods:{
        init(){
            this.getToken(getAboutUsApi,{},res=>{
                console.log(res)
                this.content=res.data[0].about_content
            })
        }
    }
}
</script>
<style lang="stylus" scoped>
.introduction
    padding:10px;
    .content
        padding:0 30px;
        p
            margin:30px 0;
            color:#666;
            text-indent:2rem;  
            line-height:30px;      
</style>